// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__29GeT","label":"SetPasswdForm_label__3BaNM"};